import axios, { AxiosInstance } from 'axios';
import { msalInstance } from '../auth/AuthProvider';
import { apiScopes } from '../auth/msalConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const apiClient: AxiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(async (config) => {
  const account = msalInstance.getActiveAccount();
  if (account) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...apiScopes,
        account,
      });
      config.headers.Authorization = `Bearer ${response.accessToken}`;
    } catch (error) {
      console.warn('Silent token failed, trying redirect...', error);
      try {
        await msalInstance.acquireTokenRedirect(apiScopes);
      } catch (redirectError) {
        console.error('Token redirect failed', redirectError);
      }
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      try {
        await msalInstance.acquireTokenRedirect(apiScopes);
      } catch {
        // Redirect will navigate away
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;

export async function getAccessToken(): Promise<string | null> {
  const account = msalInstance.getActiveAccount();
  if (!account) return null;
  try {
    const response = await msalInstance.acquireTokenSilent({
      ...apiScopes,
      account,
    });
    return response.accessToken;
  } catch {
    return null;
  }
}
